import React, { useMemo } from 'react';
import loadIcons from '../../utils/loadIcons';
import RowMarquee from '../RowMarquee/RowMarquee';
import './IconsCarousel.scss';

export default function IconsCarousel() {
  // Charge et regroupe les icônes par dossier.
  const iconsByFolder = useMemo(() => loadIcons(), []);

  // Récupère la liste des dossiers (clés)
  const folders = Object.keys(iconsByFolder).sort();

  return (
    <section className="icons-carousel">
      <h2 className="carousel-title">Filtres & Types de Plats</h2>
      <p className="carousel-subtitle">
        Retrouvez ici les différents <span className="highlight">filtres </span>
        par pays, par type de plat et même par régimes alimentaires
        (<span className="highlight">Halal</span>,
        <span className="highlight">Végétarien</span>,
        <span className="highlight">Sans Gluten</span>…),
        afin de dénicher le spot idéal en un clin d’œil.
      </p>

      {folders.map((folder, index) => (
        <div className="carousel-row" key={folder}>

          <RowMarquee
            icons={iconsByFolder[folder]}
            direction={index % 2 ? "right" : "left"}
            duration={40}
          />
        </div>
      ))}
    </section>
  );
}
